var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHarmony(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9953 0C18.6257 0 24 5.37321 24 12.0024C24 18.6315 18.6257 24 12 24C5.36954 24 3.11002e-06 18.6268 3.11002e-06 12.0024C-0.00471944 5.37321 5.36954 0 11.9953 0Z",
    fill: "url(#paint0_linear_10941_39702)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.6148V8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8V12.9251C6.18441 12.8043 6.40049 12.678 6.65139 12.5525C7.42003 12.1682 8.50721 11.7963 10 11.6148ZM11 11.527V8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8V16C5 17.6569 6.34315 19 8 19C9.65685 19 11 17.6569 11 16V12.5287C11.3154 12.5099 11.6484 12.4997 12 12.4997C12.3491 12.4997 12.6823 12.4902 13 12.4725V16C13 17.6569 14.3432 19 16 19C17.6569 19 19 17.6569 19 16V8C19 6.34315 17.6569 5 16 5C14.3432 5 13 6.34315 13 8V11.4708C12.6846 11.4896 12.3516 11.4997 12 11.4997C11.6509 11.4997 11.3177 11.5092 11 11.527ZM14 12.3846V16C14 17.1046 14.8954 18 16 18C17.1046 18 18 17.1046 18 16V11.0744C17.8156 11.1951 17.5995 11.3215 17.3486 11.4469C16.58 11.8313 15.4928 12.2031 14 12.3846ZM18 9.80641C17.9642 9.84168 17.9185 9.88429 17.8621 9.93261C17.6734 10.0943 17.3637 10.3214 16.9014 10.5525C16.2624 10.872 15.3241 11.2032 14 11.3767V8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8V9.80641ZM10 12.6227C8.67589 12.7962 7.73757 13.1275 7.09861 13.4469C6.63629 13.6781 6.32657 13.9051 6.1379 14.0669C6.08153 14.1152 6.03583 14.1578 6 14.1931V16C6 17.1046 6.89543 18 8 18C9.10457 18 10 17.1046 10 16V12.6227Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10941_39702",
    x1: 24,
    y1: 0,
    x2: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DF7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03B0E8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarmony);
export default __webpack_public_path__ + "static/media/harmony.d641cf8de7f75ccb7ef3f5c6bdd263ec.svg";
export { ForwardRef as ReactComponent };